// TOP LEVEL IMPORTS
import React from 'react';
// ANT
import Button from 'components/common/Button';
// COMPONENTS
import InvoicePageHeader from '../InvoicePageHeader';
import Result from 'components/common/Result';

const CompleteScreen = ({ currentPageHeader, invoiceById, history }) => (
  <div style={s.container}>
    <InvoicePageHeader current={currentPageHeader} />
    <div className="contract-step-container">
      <Result type="success" title="We have sent the invoice!" description={"We will email you when they've paid..."} />
      <Button
        onClick={() => {
          if (invoiceById && invoiceById.client && invoiceById.client._id) {
            history.push(`/app/clients/${invoiceById.client._id}`);
          } else {
            history.push('/clients');
          }
          window.location.reload();
        }}
        type="primary"
        size="large"
        className="contract-flow-btn"
      >
        BACK TO DASHBOARD
      </Button>
    </div>
  </div>
);

const s = {
  container: {
    width: '100%',
    height: '100%',
  },
  stepContainer: {
    flex: 5,
    minHeight: 405,
    padding: 5,
    maxWidth: '100%',
  },
};

export default CompleteScreen;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/CompleteScreen/index.js